import { Col } from "antd";
import { ChangeEvent } from "react";
import { Field, FormikProps } from "formik";
import styles from "../../lessonsForm.module.css";
import { LessonInput } from "./../../../../../__generated__/gql-types/globalTypes";

const LESSON_NAME_TITLE = "Nombre de la lección SEP";

interface ISEPLessonNameProps {
  errors: FormikProps<any>["errors"];
  touched: FormikProps<any>["touched"];
  initialValues: LessonInput;
  setInitialValues: (initialValues: LessonInput) => void;
}

export function SEPLessonName({
  errors,
  touched,
  initialValues,
  setInitialValues,
}: ISEPLessonNameProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInitialValues({
      ...initialValues,
      sep_name: e.target.value,
    });
  };

  return (
    <Col>
      <label htmlFor=""> {LESSON_NAME_TITLE}</label>
      <Field
        type="text"
        name="sep_name"
        errors={errors}
        touched={touched}
        onChange={handleChange}
        title="Nombre de lección SEP"
        value={initialValues?.sep_name}
        className={styles.formFields}
      />
    </Col>
  );
}
